import { Injectable, RendererFactory2, inject, DOCUMENT } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DocumentService {
  readonly #document = inject(DOCUMENT);
  readonly #rendererFactory = inject(RendererFactory2);

  readonly #renderer = this.#rendererFactory.createRenderer(null, null);

  get body() {
    return this.#document.body;
  }

  get documentElement() {
    return this.#document.documentElement;
  }

  getElementById(elementId: string): HTMLElement | null {
    return this.#document.getElementById(elementId);
  }

  addClassesTo(el: HTMLElement, classArr: string[]): void {
    classArr.forEach((className) => this.#renderer.addClass(el, className));
  }

  removeClassesFrom(el: HTMLElement, classArr: string[]): void {
    classArr.forEach((className) => this.#renderer.removeClass(el, className));
  }

  setStyle(el: HTMLElement, styles: { [key: string]: string }): void {
    for (const style in styles) {
      this.#renderer.setStyle(el, style, styles[style]);
    }
  }
}
